import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as compose from 'lodash.flowright';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import AsideNavbar from '../components/navbars/AsideNavbar';
import Navbars from '../components/navbars/Navbars';

// ---- Queries: category -> sub-category -> videos -------------------
const GET_VIDEO_CLASS_CATEGORIES = gql`
    query($institute_id:Int){
        getVideoClassCategories(institute_id:$institute_id){
            id
            institute_id
            video_category
            estatus
        }
    }
`;

const GET_VIDEO_CLASS_SUBCATEGORIES = gql`
    query($video_category_id:Int){
        getVideoClassSubCategories(video_category_id:$video_category_id){
            id
            video_sub_category
            description
            video_category_id
            estatus
        }
    }
`;

const GET_VIDEO_CLASS_VIDEOS = gql`
    query($video_sub_category_id:Int, $institute_id:Int){
        getVideoClassVideos(video_sub_category_id:$video_sub_category_id, institute_id:$institute_id){
            id
            paid_video
            class_id
            subject_id
            title
            description
            video_url
            doc_file
            video_date
            inserted_time
            class_name
            subject_name
            subject_color
            lecturer_name
        }
    }
`;

// ---- Design tokens -------------------------------------------------
const NAVY = '#1d2b64';
const ACCENT = '#5b6cff';
const AMBER = '#ffc107';

const SHIMMER_CSS = `
@keyframes vcShimmer { 0% { background-position: -420px 0; } 100% { background-position: 420px 0; } }
.vc-shimmer { background: linear-gradient(90deg, #eef0f5 25%, #f6f7fc 50%, #eef0f5 75%); background-size: 840px 100%; animation: vcShimmer 1.25s ease-in-out infinite; border-radius: 8px; }
.vc-subcard { transition: all .18s ease; }
.vc-subcard:hover { box-shadow: 0 12px 30px rgba(29,43,100,0.14); transform: translateY(-3px); }
.vc-subcard:hover .vc-arrow { background: ${NAVY}; }
.vc-card:hover { box-shadow: 0 10px 28px rgba(29,43,100,0.13); transform: translateY(-2px); }
.vc-table tbody tr { border-top: 1px solid #eef0f7; }
.vc-table tbody tr:hover { background: #f7f8ff; }
.vc-play-btn:hover { background: ${NAVY} !important; transform: scale(1.08); }
.vc-notes-btn:hover { background: ${NAVY} !important; color: #fff !important; text-decoration: none; box-shadow: 0 6px 16px rgba(29,43,100,0.4) !important; }
.vc-page-btn:hover { border-color: ${ACCENT} !important; color: ${ACCENT}; }
.vc-crumb-link { cursor: pointer; }
.vc-crumb-link:hover { text-decoration: underline; }
/* Full-viewport overlay so the player sits dead-center of the page, above the sidebar */
.vc-overlay { position: fixed; inset: 0; z-index: 100000; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(15,22,55,0.62); animation: vcFade .15s ease; }
.vc-player-box { width: 100%; max-width: 820px; max-height: 92vh; overflow-y: auto; background: #fff; border-radius: 14px; box-shadow: 0 24px 60px rgba(15,22,55,0.4); }
@keyframes vcFade { from { opacity: 0; } to { opacity: 1; } }
`;

const youTubeId = (url) => {
    if (!url) return null;
    const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/);
    return m ? m[1] : null;
};

const vimeoId = (url) => {
    if (!url) return null;
    const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : null;
};

// Tells the player how to render a given video url.
// { kind: 'youtube'|'vimeo'|'file'|'iframe', src }
const resolvePlayer = (url) => {
    if (!url) return null;
    const yt = youTubeId(url);
    if (yt) return { kind: 'youtube', src: `https://www.youtube.com/embed/${yt}?autoplay=1&rel=0` };
    const vm = vimeoId(url);
    if (vm) return { kind: 'vimeo', src: `https://player.vimeo.com/video/${vm}?autoplay=1` };
    if (/\.(mp4|webm|ogg|m3u8)(\?.*)?$/i.test(url)) return { kind: 'file', src: url };
    return { kind: 'iframe', src: url };
};

// Placeholder card for the sub-category grid while loading.
const ShimmerSubCard = () => (
    <Col md={4} sm={6} className="mb-4">
        <div style={{ background: '#fff', borderRadius: '14px', borderTop: '3px solid #e7eaf3', boxShadow: '0 6px 22px rgba(29,43,100,0.06)', padding: '20px', height: '150px' }}>
            <div className="vc-shimmer mb-3" style={{ width: '55%', height: '18px' }}></div>
            <div className="vc-shimmer mb-2" style={{ width: '90%', height: '11px' }}></div>
            <div className="vc-shimmer" style={{ width: '70%', height: '11px' }}></div>
        </div>
    </Col>
);

class VideoClasses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: Cookies.get("toggle") || "wrapper sidebar-enable",
            categories: [],
            subCatMap: {},            // categoryId -> [sub-categories]
            view: 'browse',           // 'browse' (categories+subcats) | 'videos'
            activeCategory: null,
            activeSubCategory: null,
            videos: [],
            subjectFilter: 'ALL',
            searchText: '',
            timeFilter: 'all',        // 'all' | 'latest' (24h) | 'previous'
            sortOrder: 'newest',      // 'newest' | 'oldest' (by upload time)
            currentPage: 1,
            pageSize: 10,
            selectedVideo: null,      // video shown in the player modal
            loadingBrowse: true,
            loadingVideos: false,
        };
    }

    componentDidMount() {
        this.fetchBrowseData();
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.body.style.overflow = '';
    }

    handleKeyDown = (e) => {
        if (e.key === 'Escape' && this.state.selectedVideo) this.closeVideo();
    };

    menuToggler = () => {
        const toggled = this.state.toggled;
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    instituteId = () => parseInt(Cookies.get("institution_id")) || 0;

    // Load every category + its sub-categories so the browse screen can render
    // each category as a heading with its sub-category cards underneath.
    fetchBrowseData = async () => {
        this.setState({ loadingBrowse: true });
        try {
            const { data } = await this.props.client.query({
                query: GET_VIDEO_CLASS_CATEGORIES,
                variables: { institute_id: this.instituteId() },
                fetchPolicy: "network-only"
            });
            const categories = (data && data.getVideoClassCategories) || [];

            // Fetch sub-categories for all categories in parallel.
            const lists = await Promise.all(categories.map((c) =>
                this.props.client.query({
                    query: GET_VIDEO_CLASS_SUBCATEGORIES,
                    variables: { video_category_id: c.id },
                    fetchPolicy: "network-only"
                })
                    .then((r) => ({ id: c.id, subs: (r.data && r.data.getVideoClassSubCategories) || [] }))
                    .catch(() => ({ id: c.id, subs: [] }))
            ));
            const subCatMap = {};
            lists.forEach((x) => { subCatMap[x.id] = x.subs; });

            this.setState({ categories, subCatMap, loadingBrowse: false });
        } catch (e) {
            this.setState({ categories: [], subCatMap: {}, loadingBrowse: false });
        }
    };

    // Open a sub-category's videos screen.
    openSubCategory = async (cat, sub) => {
        this.setState({
            view: 'videos', activeCategory: cat, activeSubCategory: sub,
            subjectFilter: 'ALL', searchText: '', timeFilter: 'all', sortOrder: 'newest',
            currentPage: 1, videos: [], loadingVideos: true
        });
        try {
            const { data } = await this.props.client.query({
                query: GET_VIDEO_CLASS_VIDEOS,
                variables: { video_sub_category_id: sub.id, institute_id: this.instituteId() },
                fetchPolicy: "network-only"
            });
            const videos = (data && data.getVideoClassVideos) || [];
            this.setState({ videos, loadingVideos: false });
        } catch (e) {
            this.setState({ videos: [], loadingVideos: false });
        }
    };

    backToBrowse = () => this.setState({ view: 'browse', activeSubCategory: null });

    // Play the video in an in-page modal instead of a new tab.
    // Lock background page scroll while the player is open.
    openVideo = (v) => {
        if (v.video_url) {
            document.body.style.overflow = 'hidden';
            this.setState({ selectedVideo: v });
        }
    };

    closeVideo = () => {
        document.body.style.overflow = '';
        this.setState({ selectedVideo: null });
    };

    // Distinct subject names across the loaded videos (for the filter tabs).
    // No "ALL" tab — all subjects show by default; clicking a subject filters to it,
    // clicking the active subject again clears back to all.
    subjectTabs = () => {
        const seen = [];
        this.state.videos.forEach((v) => { if (v.subject_name && !seen.includes(v.subject_name)) seen.push(v.subject_name); });
        return seen;
    };

    // Upload time (ms) from inserted_time; falls back to video_date. 0 if unknown.
    uploadMs = (v) => {
        if (v.inserted_time) {
            const t = new Date(v.inserted_time).getTime();
            if (!isNaN(t)) return t;
        }
        if (v.video_date) {
            const t = new Date(v.video_date + 'T00:00:00').getTime();
            if (!isNaN(t)) return t;
        }
        return 0;
    };

    // Hours since upload (Infinity if unknown).
    hoursSince = (v) => {
        const t = this.uploadMs(v);
        if (!t) return Infinity;
        return (new Date().getTime() - t) / 3600000;
    };

    // A video is "Latest"/NEW for the first 24 hours after upload, then it's a
    // previous (older) video — so students always see a clear cut-off.
    isNew = (v) => this.hoursSince(v) < 24;

    // Format an ISO 'YYYY-MM-DD' date as 'DD/MM/YYYY' for display.
    formatDate = (s) => {
        if (!s) return '—';
        const parts = s.split('-');
        if (parts.length !== 3) return s;
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    };

    // Upload clock time shown in small letters under the date (e.g. "2:30 PM").
    uploadClock = (v) => {
        if (!v.inserted_time) return '';
        const d = new Date(v.inserted_time);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    // Human label for how long ago a NEW video was uploaded (e.g. "3h ago").
    uploadedAgo = (v) => {
        const h = this.hoursSince(v);
        if (!isFinite(h)) return '';
        if (h < 1) {
            const m = Math.max(1, Math.floor(h * 60));
            return `${m}m ago`;
        }
        return `${Math.floor(h)}h ago`;
    };

    filteredVideos = () => {
        const { videos, subjectFilter, searchText, timeFilter, sortOrder } = this.state;
        const q = searchText.trim().toLowerCase();

        const arr = videos.filter((v) => {
            if (!(subjectFilter === 'ALL' || v.subject_name === subjectFilter)) return false;
            // Latest = uploaded < 24h ago; Previous = everything older.
            if (timeFilter === 'latest' && !this.isNew(v)) return false;
            if (timeFilter === 'previous' && this.isNew(v)) return false;
            if (q) {
                // Search across title, description, lecturer, class and subject.
                const hay = [v.title, v.description, v.lecturer_name, v.class_name, v.subject_name]
                    .filter(Boolean).join(' ').toLowerCase();
                if (!hay.includes(q)) return false;
            }
            return true;
        });

        // Sort by upload time, newest first (descending). Falls back to id desc
        // so rows are always in a stable latest-first order.
        return arr.sort((a, b) => {
            const da = this.uploadMs(a), db = this.uploadMs(b);
            if (db !== da) return sortOrder === 'oldest' ? da - db : db - da;
            return sortOrder === 'oldest' ? (a.id - b.id) : (b.id - a.id);
        });
    };

    // ================= BROWSE: categories + sub-category cards ========
    renderBrowse() {
        const { categories, subCatMap, loadingBrowse } = this.state;

        if (loadingBrowse) {
            return (
                <>
                    <div className="vc-shimmer mb-3" style={{ width: '140px', height: '24px' }}></div>
                    <Row>{Array.from({ length: 3 }).map((_, i) => <ShimmerSubCard key={i} />)}</Row>
                </>
            );
        }
        if (categories.length === 0) {
            return (
                <div className="text-center py-5" style={{ background: '#fff', borderRadius: '16px', color: '#9aa1c4' }}>
                    <i className="fas fa-folder-open mb-2" style={{ fontSize: '30px', display: 'block' }}></i>
                    No video categories available yet.
                </div>
            );
        }

        return categories.map((cat) => {
            const subs = subCatMap[cat.id] || [];
            return (
                <div key={cat.id} className="mb-4">
                    {/* Category heading (e.g. "NEET") */}
                    <div className="d-flex align-items-center mb-3">
                        <span style={{ width: '14px', height: '14px', borderRadius: '4px 4px 4px 0', background: ACCENT, marginRight: '10px' }}></span>
                        <h5 className="mb-0" style={{ color: NAVY, fontWeight: 800, letterSpacing: '0.3px' }}>{cat.video_category}</h5>
                    </div>

                    {subs.length === 0 ? (
                        <div className="mb-2" style={{ color: '#9aa1c4', fontSize: '13px' }}>No sub-categories under this category.</div>
                    ) : (
                        <Row>
                            {subs.map((s) => (
                                <Col md={4} sm={6} className="mb-4" key={s.id}>
                                    <div className="vc-subcard h-100" onClick={() => this.openSubCategory(cat, s)}
                                        style={{ cursor: 'pointer', background: '#fff', borderRadius: '14px', borderTop: `3px solid ${ACCENT}`, boxShadow: '0 6px 22px rgba(29,43,100,0.06)', padding: '20px 22px', display: 'flex', flexDirection: 'column' }}>
                                        <div className="d-flex align-items-start justify-content-between">
                                            <h6 className="mb-0" style={{ color: NAVY, fontWeight: 700, fontSize: '16px', paddingRight: '12px' }}>{s.video_sub_category}</h6>
                                            <span className="vc-arrow d-flex align-items-center justify-content-center" style={{ flexShrink: 0, width: '34px', height: '34px', borderRadius: '50%', background: ACCENT, transition: 'background .18s ease' }}>
                                                <i className="fas fa-arrow-right" style={{ color: '#fff', fontSize: '13px' }}></i>
                                            </span>
                                        </div>
                                        {s.description && (
                                            <p className="mb-0 mt-2" style={{ color: '#8189aa', fontSize: '13px', lineHeight: '1.5', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                {s.description}
                                            </p>
                                        )}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>
            );
        });
    }

    // ================= VIDEOS: breadcrumb + filters + grid ============
    renderVideosScreen() {
        const { activeCategory, activeSubCategory, loadingVideos, subjectFilter, searchText, timeFilter } = this.state;
        const tabs = this.subjectTabs();
        const list = this.filteredVideos();
        const newCount = this.state.videos.filter((v) => this.isNew(v)).length;

        // Pagination
        const { pageSize } = this.state;
        const totalPages = Math.max(1, Math.ceil(list.length / pageSize));
        const currentPage = Math.min(this.state.currentPage, totalPages);
        const startIdx = (currentPage - 1) * pageSize;
        const pageItems = list.slice(startIdx, startIdx + pageSize);

        return (
            <>
                {/* Breadcrumb + subject filter row */}
                <div className="d-flex align-items-center justify-content-between flex-wrap mb-3">
                    <div className="d-flex align-items-center mb-2" style={{ fontSize: '15px', fontWeight: 700 }}>
                        <span className="vc-crumb-link" onClick={this.backToBrowse} style={{ color: ACCENT }}>Video Classes</span>
                        <i className="fas fa-chevron-right mx-2" style={{ fontSize: '10px', color: '#c2c7de' }}></i>
                        <span className="vc-crumb-link" onClick={this.backToBrowse} style={{ color: ACCENT }}>{activeCategory ? activeCategory.video_category : ''}</span>
                        <i className="fas fa-chevron-right mx-2" style={{ fontSize: '10px', color: '#c2c7de' }}></i>
                        <span style={{ color: NAVY }}>{activeSubCategory ? activeSubCategory.video_sub_category : ''}</span>
                    </div>

                    {/* Filter group (time / sort / subject) */}
                    {!loadingVideos && (
                    <div className="d-flex align-items-center flex-wrap">
                        {/* Latest (uploaded < 24h) vs Previous (older) — clear cut-off */}
                        <div className="d-flex align-items-center mb-2 mr-2" style={{ border: '1.5px solid #e7eaf3', borderRadius: '10px', overflow: 'hidden', background: '#fff' }}>
                            {[{ k: 'all', l: 'All' }, { k: 'latest', l: 'Latest' }, { k: 'previous', l: 'Previous' }].map((t, i) => {
                                const active = timeFilter === t.k;
                                return (
                                    <div key={t.k} onClick={() => this.setState({ timeFilter: t.k, currentPage: 1 })}
                                        title={t.k === 'latest' ? 'Uploaded in the last 24 hours' : t.k === 'previous' ? 'Older than 24 hours' : 'All videos'}
                                        style={{
                                            cursor: 'pointer', padding: '8px 14px', fontSize: '12.5px', fontWeight: 700,
                                            color: active ? '#fff' : '#8189aa',
                                            background: active ? ACCENT : 'transparent',
                                            borderLeft: i === 0 ? 'none' : '1.5px solid #eef0f5'
                                        }}>
                                        {t.k === 'latest' && <i className="fas fa-bolt mr-1" style={{ fontSize: '10px' }}></i>}{t.l}
                                        {t.k === 'latest' && newCount > 0 && (
                                            <span className="ml-1" style={{ background: active ? 'rgba(255,255,255,0.25)' : '#fdeaec', color: active ? '#fff' : '#e0414f', borderRadius: '10px', padding: '0 6px', fontSize: '10px' }}>{newCount}</span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {/* Subject filter tabs (no ALL — click to filter, click again to clear) */}
                        {tabs.length > 0 && (
                        <div className="d-flex align-items-center mb-2" style={{ border: '1.5px solid #e7eaf3', borderRadius: '10px', overflow: 'hidden', background: '#fff' }}>
                            {tabs.map((t, i) => {
                                const active = subjectFilter === t;
                                return (
                                    <div key={t} onClick={() => this.setState({ subjectFilter: active ? 'ALL' : t, currentPage: 1 })}
                                        title={active ? 'Click to show all subjects' : `Show only ${t}`}
                                        style={{
                                            cursor: 'pointer', padding: '8px 16px', fontSize: '12.5px', fontWeight: 700,
                                            textTransform: 'uppercase', letterSpacing: '0.4px',
                                            color: active ? '#fff' : '#8189aa',
                                            background: active ? NAVY : 'transparent',
                                            borderLeft: i === 0 ? 'none' : '1.5px solid #eef0f5'
                                        }}>
                                        {t}
                                    </div>
                                );
                            })}
                        </div>
                        )}
                    </div>
                    )}
                </div>

                {/* Search box — left aligned, top of the table */}
                {!loadingVideos && this.state.videos.length > 0 && (
                    <div className="d-flex align-items-center mb-3" style={{ border: '1.5px solid #e7eaf3', borderRadius: '10px', background: '#fff', padding: '0 12px', height: '40px', width: '280px', maxWidth: '100%' }}>
                        <i className="fas fa-search" style={{ color: '#aeb4d0', fontSize: '13px' }}></i>
                        <input
                            type="text"
                            value={searchText}
                            placeholder="Search videos…"
                            onChange={(e) => this.setState({ searchText: e.target.value, currentPage: 1 })}
                            style={{ border: 'none', outline: 'none', height: '38px', fontSize: '13px', color: '#2f3654', background: 'transparent', padding: '0 8px', flex: 1 }}
                        />
                        {searchText && (
                            <i className="fas fa-times" onClick={() => this.setState({ searchText: '', currentPage: 1 })}
                                style={{ color: '#aeb4d0', fontSize: '13px', cursor: 'pointer' }}></i>
                        )}
                    </div>
                )}

                {/* Videos table */}
                {loadingVideos ? (
                    <div style={{ background: '#fff', borderRadius: '14px', border: '1px solid #eef0f7', padding: '14px 16px' }}>
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="vc-shimmer mb-2" style={{ width: '100%', height: '40px', borderRadius: '8px' }}></div>
                        ))}
                    </div>
                ) : list.length === 0 ? (
                    <div className="text-center py-5" style={{ background: '#fff', borderRadius: '14px', color: '#9aa1c4' }}>
                        <i className="fas fa-video-slash mb-2" style={{ fontSize: '28px', display: 'block' }}></i>
                        {this.state.videos.length === 0 ? 'No videos available under this sub-category yet.' : 'No videos match your filters. Try “All” or clear the search.'}
                    </div>
                ) : (
                    <div style={{ background: '#fff', borderRadius: '14px', border: '1px solid #eef0f7', overflow: 'hidden' }}>
                        <div style={{ overflowX: 'auto' }}>
                            <table className="table mb-0 vc-table" style={{ minWidth: '900px' }}>
                                <thead>
                                    <tr style={{ background: '#f6f7fc' }}>
                                        {['#', 'Title', 'Description', 'Lecturer', 'Class', 'Subject', 'Date', 'Notes', 'Action'].map((h) => (
                                            <th key={h} style={{ borderTop: 'none', borderBottom: '1px solid #eef0f7', color: '#7c84a3', fontWeight: 700, fontSize: '10.5px', letterSpacing: '0.6px', textTransform: 'uppercase', padding: '12px 14px', whiteSpace: 'nowrap' }}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageItems.map((v, idx) => {
                                        const subjColor = v.subject_color || ACCENT;
                                        return (
                                            <tr key={v.id} style={{ fontSize: '13px', color: '#5a6285' }}>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', color: '#9aa1c4' }}>{startIdx + idx + 1}</td>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', fontWeight: 700, color: NAVY, minWidth: '200px' }}>
                                                    {v.title}
                                                    {this.isNew(v) && (
                                                        <span className="ml-2" style={{ background: '#e0414f', color: '#fff', borderRadius: '4px', fontSize: '9px', fontWeight: 800, letterSpacing: '0.5px', padding: '2px 5px', verticalAlign: 'middle' }}>NEW</span>
                                                    )}
                                                </td>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', maxWidth: '240px' }}>
                                                    <span style={{ display: 'block', color: '#8189aa', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={v.description || ''}>{v.description || '—'}</span>
                                                </td>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                    {v.lecturer_name ? <><i className="fas fa-chalkboard-teacher mr-1" style={{ color: '#c2c7de', fontSize: '11px' }}></i>{v.lecturer_name}</> : '—'}
                                                </td>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>{v.class_name || '—'}</td>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                    {v.subject_name ? (
                                                        <span className="px-2 py-1" style={{ background: subjColor + '22', color: subjColor, borderRadius: '6px', fontSize: '11px', fontWeight: 700 }}>{v.subject_name}</span>
                                                    ) : '—'}
                                                </td>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', whiteSpace: 'nowrap', color: '#9aa1c4', lineHeight: '1.3' }}>
                                                    <div style={{ color: '#5a6285', fontWeight: 600 }}>{this.formatDate(v.video_date)}</div>
                                                    {this.isNew(v) ? (
                                                        <div style={{ color: '#12a45b', fontWeight: 700, fontSize: '10.5px' }}><i className="fas fa-clock mr-1" style={{ fontSize: '9px' }}></i>{this.uploadedAgo(v)}</div>
                                                    ) : this.uploadClock(v) ? (
                                                        <div style={{ color: '#aeb4d0', fontSize: '10.5px' }}>{this.uploadClock(v)}</div>
                                                    ) : null}
                                                </td>
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                    {v.doc_file ? (
                                                        <a href={v.doc_file} target="_blank" rel="noopener noreferrer" download
                                                            className="vc-notes-btn d-inline-flex align-items-center"
                                                            title="Download notes (PDF)"
                                                            style={{ color: '#fff', background: ACCENT, fontWeight: 700, fontSize: '11.5px', padding: '5px 10px', borderRadius: '7px', whiteSpace: 'nowrap' }}>
                                                            <i className="fas fa-download mr-1"></i>Download
                                                        </a>
                                                    ) : '—'}
                                                </td>
                                                {/* Action: play the video in the in-page popup */}
                                                <td style={{ padding: '12px 14px', verticalAlign: 'middle' }}>
                                                    <span className="vc-play-btn d-inline-flex align-items-center justify-content-center"
                                                        title="Play video" onClick={() => this.openVideo(v)}
                                                        style={{ cursor: 'pointer', width: '34px', height: '34px', borderRadius: '50%', background: ACCENT, transition: 'all .15s ease' }}>
                                                        <i className="fas fa-play" style={{ color: '#fff', fontSize: '12px', marginLeft: '2px' }}></i>
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination footer */}
                        {list.length > 0 && (
                            <div className="d-flex align-items-center justify-content-between flex-wrap px-3 py-3" style={{ borderTop: '1px solid #eef0f7' }}>
                                <div className="d-flex align-items-center">
                                    <small style={{ color: '#9aa1c4', fontWeight: 600 }}>
                                        Showing {startIdx + 1}–{Math.min(startIdx + pageSize, list.length)} of {list.length}
                                    </small>
                                    {/* Rows-per-page selector */}
                                    <small className="ml-3 mr-2" style={{ color: '#9aa1c4', fontWeight: 600 }}>Rows:</small>
                                    <select value={pageSize}
                                        onChange={(e) => this.setState({ pageSize: parseInt(e.target.value), currentPage: 1 })}
                                        style={{ height: '32px', border: '1.5px solid #e7eaf3', borderRadius: '8px', color: '#5a6285', fontSize: '12.5px', fontWeight: 700, padding: '0 8px', outline: 'none', cursor: 'pointer', background: '#fff' }}>
                                        {[10, 25, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
                                    </select>
                                </div>
                                {(
                                    <div className="d-flex align-items-center">
                                        <span onClick={() => currentPage > 1 && this.setState({ currentPage: currentPage - 1 })}
                                            className="vc-page-btn d-inline-flex align-items-center justify-content-center mr-1"
                                            style={{ cursor: currentPage > 1 ? 'pointer' : 'not-allowed', opacity: currentPage > 1 ? 1 : 0.45, width: '32px', height: '32px', borderRadius: '8px', border: '1.5px solid #e7eaf3', color: '#5a6285' }}>
                                            <i className="fas fa-chevron-left" style={{ fontSize: '11px' }}></i>
                                        </span>
                                        {this.pageNumbers(currentPage, totalPages).map((p, i) => (
                                            p === '…' ? (
                                                <span key={`e${i}`} className="mx-1" style={{ color: '#aeb4d0' }}>…</span>
                                            ) : (
                                                <span key={p} onClick={() => this.setState({ currentPage: p })}
                                                    className="vc-page-btn d-inline-flex align-items-center justify-content-center mx-1"
                                                    style={{
                                                        cursor: 'pointer', minWidth: '32px', height: '32px', padding: '0 8px', borderRadius: '8px',
                                                        fontSize: '12.5px', fontWeight: 700,
                                                        border: p === currentPage ? `1.5px solid ${ACCENT}` : '1.5px solid #e7eaf3',
                                                        background: p === currentPage ? ACCENT : '#fff',
                                                        color: p === currentPage ? '#fff' : '#5a6285'
                                                    }}>
                                                    {p}
                                                </span>
                                            )
                                        ))}
                                        <span onClick={() => currentPage < totalPages && this.setState({ currentPage: currentPage + 1 })}
                                            className="vc-page-btn d-inline-flex align-items-center justify-content-center ml-1"
                                            style={{ cursor: currentPage < totalPages ? 'pointer' : 'not-allowed', opacity: currentPage < totalPages ? 1 : 0.45, width: '32px', height: '32px', borderRadius: '8px', border: '1.5px solid #e7eaf3', color: '#5a6285' }}>
                                            <i className="fas fa-chevron-right" style={{ fontSize: '11px' }}></i>
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </>
        );
    }

    // Page-number list with ellipsis: 1 … 4 5 6 … 20
    pageNumbers = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
        const pages = [1];
        const left = Math.max(2, current - 1);
        const right = Math.min(total - 1, current + 1);
        if (left > 2) pages.push('…');
        for (let p = left; p <= right; p++) pages.push(p);
        if (right < total - 1) pages.push('…');
        pages.push(total);
        return pages;
    };

    // In-page video player — a fixed full-viewport overlay centered on the page.
    renderPlayerModal() {
        const v = this.state.selectedVideo;
        if (!v) return null;
        const player = resolvePlayer(v.video_url);

        return (
            <div className="vc-overlay" onClick={this.closeVideo}>
                <div className="vc-player-box" onClick={(e) => e.stopPropagation()}>
                    {/* Header */}
                    <div style={{ background: `linear-gradient(120deg, ${NAVY} 0%, #2c3a86 60%, ${ACCENT} 130%)`, padding: '14px 20px' }}>
                        <div className="d-flex align-items-start justify-content-between">
                            <div style={{ paddingRight: '14px' }}>
                                <h6 className="mb-0" style={{ color: '#fff', fontWeight: 700, fontSize: '15.5px' }}>{v.title}</h6>
                                <div className="mt-1">
                                    {v.subject_name && <span className="mr-2" style={{ color: '#fff', background: 'rgba(255,255,255,0.18)', borderRadius: '6px', padding: '2px 8px', fontSize: '11px', fontWeight: 700 }}>{v.subject_name}</span>}
                                    {v.class_name && <span style={{ color: '#c3c9ee', fontSize: '11.5px' }}>{v.class_name}</span>}
                                </div>
                            </div>
                            <i className="fas fa-times" style={{ color: '#c3c9ee', cursor: 'pointer', fontSize: '20px' }} onClick={this.closeVideo}></i>
                        </div>
                    </div>

                    {/* Player — responsive 16:9 */}
                    <div style={{ background: '#000' }}>
                        <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                            {player && player.kind === 'file' ? (
                                <video src={player.src} controls autoPlay
                                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', background: '#000' }} />
                            ) : player ? (
                                <iframe title={v.title} src={player.src}
                                    frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
                                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} />
                            ) : (
                                <div className="d-flex align-items-center justify-content-center" style={{ position: 'absolute', inset: 0, color: '#fff' }}>Video unavailable</div>
                            )}
                        </div>
                    </div>

                    {/* Footer: description + notes */}
                    <div style={{ background: '#fff', padding: '14px 20px', borderBottomLeftRadius: '14px', borderBottomRightRadius: '14px' }}>
                        {v.description && <p className="mb-2" style={{ color: '#5a6285', fontSize: '13px', lineHeight: '1.5' }}>{v.description}</p>}
                        <div className="d-flex align-items-center justify-content-between" style={{ fontSize: '12px', color: '#9aa1c4' }}>
                            <span>{v.video_date ? <><i className="far fa-calendar-alt mr-1"></i>{this.formatDate(v.video_date)}</> : ''}</span>
                            {v.doc_file && (
                                <a href={v.doc_file} target="_blank" rel="noopener noreferrer" download className="vc-notes-btn d-inline-flex align-items-center"
                                    title="Download notes (PDF)"
                                    style={{ color: '#fff', background: ACCENT, fontWeight: 700, fontSize: '12.5px', padding: '7px 14px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(91,108,255,0.35)', transition: 'all .15s ease' }}>
                                    <i className="fas fa-download mr-2"></i>Download Notes (PDF)
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { view } = this.state;
        return (
            <div className={this.state.toggled}>
                {this.renderPlayerModal()}
                <style>{SHIMMER_CSS}</style>
                <div className="student main-wrapper">
                    <div className="student header-area">
                        <Navbars onClick={() => this.menuToggler()} />
                    </div>
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />

                    <div className="content-wrapper pt-0">
                        <Container className="py-4">
                            {/* Gradient hero header (hidden on the videos screen to give room to the breadcrumb) */}
                            {view === 'browse' && (
                                <div className="mb-4" style={{ background: `linear-gradient(120deg, ${NAVY} 0%, #2c3a86 60%, ${ACCENT} 130%)`, borderRadius: '18px', padding: '22px 26px' }}>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center justify-content-center mr-3" style={{ width: '50px', height: '50px', borderRadius: '14px', background: 'rgba(255,255,255,0.14)' }}>
                                            <i className="fas fa-photo-video" style={{ color: AMBER, fontSize: '22px' }}></i>
                                        </div>
                                        <div>
                                            <h4 className="mb-0" style={{ color: '#fff', fontWeight: 700 }}>Video Classes</h4>
                                            <small style={{ color: '#c3c9ee' }}>Choose a category, open a sub-category, and watch its videos</small>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {view === 'browse' ? this.renderBrowse() : this.renderVideosScreen()}
                        </Container>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(withApollo)(withRouter(VideoClasses));
